import { Route, Switch } from "react-router-dom";

// Import pages (JSX components) below.
import Home from "./pages/Home";
import NotFound from "./pages/errors/404";
import { Roadmap } from "./components/pages/roadmap/Roadmap";
import Features from "./pages/Features";
import RopeAccess from "./components/pages/industries/RopeAccess";
import PlantHire from "./components/pages/industries/PlantHire";
import Equipment from "./components/pages/industries/Equipment";
import ToolIndustry from "./components/pages/industries/ToolIndustry"

/**
 * @description Maps pages to their matching route/path.  
 * */
export default function Routes() {
    return (
        <Switch>
            <Route exact path="/">
                <Home />
            </Route>

            <Route exact path="/Features">
                <Features />
            </Route>

            <Route exact path="/Roadmap">
                <Roadmap />
            </Route>

            <Route exact path="/Industries/RopeAccess">
                <RopeAccess />
            </Route>

            <Route exact path="/Industries/PlantHire">
                <PlantHire />
            </Route>

            <Route exact path="/Industries/Equipment">
                <Equipment />
            </Route>

            <Route exact path="/Industries/Tools">
                <ToolIndustry/>
            </Route>

            { /* Error 404 */}
            <Route path="" component={NotFound} />
        </Switch>
    )
}